import * as yup from 'yup';

const InvoiceLineItemShape = yup.object().shape({
    ledgerAccount: yup.string().required('Required'),
    description: yup.string().required('Required'),
    quantity: yup.number().typeError('Required').moreThan(0, 'Required').required('Required'),
    netAmount: yup.number().typeError('Required').required('Required'),
    totalNet: yup.number().typeError('Required').required('Required'),
    totalVat: yup.number().typeError('Required').required('Required'),
    lineTotal: yup.number().typeError('Required').required('Required'),
});

export default InvoiceLineItemShape;
